import { Sort as AntdSort } from "@empglabs/backoffice-ui-kit"

const Sort = props => {
  return <AntdSort {...props} />
}

export default Sort
